import { Menu, message } from 'antd';
import { RootStateOrAny, useSelector } from 'react-redux';

export const PostMenu = ({
  editValue,
  user,
  postCreator,
  handleEditClick,
  setdeleteModal,
  setReportVisible,
}) => {
  const { roomSlug } = useSelector((state: RootStateOrAny) => ({
    roomSlug: state?.roomReducer?.roomDetail?.data?.slug,
  }));
  return (
    <Menu className="discussion-dropdown-menu p-2" style={{ borderRadius: '8px' }}>
      {user?.id === postCreator ? (
        <>
          <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
            <a onClick={() => handleEditClick(editValue)}>
              <div className="dropdown-media d-flex align-items-center px-2">
                <i className="fas fa-edit fa-lg text-muted mr-3"></i>
                <span className="mr-3">Edit post</span>
              </div>
            </a>
          </Menu.Item>
          <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
            <a onClick={() => setdeleteModal(true)}>
              <div
                className="dropdown-media d-flex align-items-center px-2"
                style={{ borderRadius: '8px' }}
              >
                <i className="fas fa-trash fa-lg text-muted mr-3"></i>
                <span>Delete post</span>
              </div>
            </a>
          </Menu.Item>
          <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
            <a
              onClick={() => {
                navigator.clipboard.writeText(
                  `${process.env.NEXT_PUBLIC_SITE_URL}room/${roomSlug}?discussion=${editValue?.id}`
                );
                message.success('Link copied');
              }}
            >
              <div
                className="dropdown-media d-flex align-items-center px-2"
                style={{ borderRadius: '8px' }}
              >
                <i className="fas fa-clipboard fa-lg text-muted mr-3"></i>
                <span>Copy Link</span>
              </div>
            </a>
          </Menu.Item>
        </>
      ) : (
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <a
            onClick={() => {
              setReportVisible(true);
            }}
          >
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-flag fa-lg text-muted mr-3"></i>
              <span>Report the post</span>
            </div>
          </a>
        </Menu.Item>
      )}
    </Menu>
  );
};
